// ============================================================
// Icon registry — UN SOLO posto per icone UI Lucide React.
// ============================================================
// Cambia qui per aggiornare ovunque: mappa categoria → componente,
// alias semantici per UI (calendario, mic, trash…), size/stroke
// di default. I consumer importano `Icon.Category.casa` /
// `Icon.Calendar` così se cambiamo icona o colore è atomico.
//
// Nota: il peso (strokeWidth) e la size di default sono gestiti dai
// consumer passando le prop (Lucide è tree-shakeable). Non wrappiamo
// in un componente intermedio per non perdere la prop `size`.

import {
  // categorie
  Briefcase, Home, Car, Users, Wallet, Bookmark,
  // blocchi / indisponibilità
  Plane, Brain, Dumbbell, CalendarClock,
  // azioni
  Check, X, Trash2, Edit3, Plus, Search, Share2, Copy,
  // navigation / chrome
  Calendar, Clock, Bell, Settings, LogOut, ChevronRight, ChevronLeft,
  ArrowRight, ArrowLeft, MoreHorizontal, Menu,
  // input
  Mic, Camera, Image as ImageIcon, FileText, Upload, Keyboard, MapPin,
  // stato / feedback
  AlertTriangle, AlertCircle, CheckCircle2, Flame, Sparkles, PartyPopper,
  Info, Inbox, BarChart3, HelpCircle, LifeBuoy, Star, Heart, ThumbsUp,
  // sistema
  Globe, Smartphone, Mail, Phone, HardHat, Shield,
  // brand/agent
  Bot, Volume2, VolumeX, MessageSquare,
} from 'lucide-react'

// ────────────────────────────────────────────────────────────
// Categorie task. Chiave = valore DB in `tasks.category`.
// ────────────────────────────────────────────────────────────
export const CategoryIcon = {
  lavoro:   Briefcase,
  casa:     Home,
  auto:     Car,
  famiglia: Users,
  budget:   Wallet,
  altro:    Bookmark,
}

// Blocchi / Indisponibilità. Chiave = valore DB in `blocchi.type`.
export const BlockIcon = {
  Lavoro:  Briefcase,
  Viaggio: Plane,
  Focus:   Brain,
  Impegno: Dumbbell,
}

// ────────────────────────────────────────────────────────────
// Alias semantici per l'app. Usare questi invece di importare
// direttamente da `lucide-react`, così una sostituzione resta
// centralizzata qui.
// ────────────────────────────────────────────────────────────
export const Icon = {
  // azioni
  Check, Close: X, Delete: Trash2, Edit: Edit3, Add: Plus, Search,
  Share: Share2, Copy,
  // navigation
  Calendar, Clock, Bell, Settings, Logout: LogOut,
  ChevronRight, ChevronLeft, ArrowRight, ArrowLeft, More: MoreHorizontal, Menu,
  // input
  Mic, Camera, Image: ImageIcon, Document: FileText, Upload,
  Keyboard, Location: MapPin,
  // stato
  Alert: AlertTriangle, AlertCircle, Success: CheckCircle2,
  Flame, Sparkles, Celebrate: PartyPopper, Info, Inbox,
  Chart: BarChart3, Help: HelpCircle, Support: LifeBuoy,
  Star, Heart, ThumbsUp,
  // sistema
  Globe, Smartphone, Mail, Phone, HardHat, Shield,
  // agent
  Bot, SpeakerOn: Volume2, SpeakerOff: VolumeX, Message: MessageSquare,
}

// Convenzione size di default (consistente con l'UI).
// I consumer possono sovrascrivere.
export const ICON_SIZE = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 22,
}
